import React, { Component, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid } from '@material-ui/core';
import { ErrorIcon, SuccessIcon } from '../../components/icons'
import Button from '../../components/ButtonCustom';
import { formatDateToDDMMYYYYHHSSFrEpoch, getCurrencySymbol } from '../../utils/util';
import Container from '../../components/Container';
import { getCurrency, getServiceChangeInfo, setServiceChangeInfo } from '../../utils/common';
import ModalAlert from '../../components/ModalAlert';
import { paths } from '../../../portal.router.config';
import crmservices from '../../wsclient/';
const queryString = require('query-string');

function PaygateResults(props) {
    const [showLoading, onShowLoading] = useState(true);
    const [message, setMessage] = useState({});
    const [paygateResult, setPaygateResult] = useState({});
    const [ready, setReady] = useState(false);
    const [order, setOrder] = useState(null);


    useEffect(() => {
        onLoad();
    }, [])

    const onLoad = async () => {
        const parsed = queryString.parse(props.location.search);
        console.log("parsed===", parsed);
        if (parsed.status === 'SUCCESS') {
            if(parsed.order_id && parsed.order_id !== "null") await onLoadOrder(parsed.order_id);
        }else{
            if(parsed.resason_code === "0"){
                showMessage(true, t('VALIDATE_PAYMENT_EXCEPTION'));
            }else if(parsed.resason_code ===  "1"){
                showMessage(true, t('CRM_ORDER_EXCEPTION'));
            }else{
                //showMessage(true, t('EXCEPTION_PROCESS'));
            }
        }
        await setPaygateResult({
            status: parsed.status,
            type: parsed.type ? parsed.type.toLocaleLowerCase() : null,
        });
        onShowLoading(false);
        setReady(true);
    }

    const onLoadOrder = async (order_id) => {
        try{
            if(order_id){
                let result = await crmservices.orders.getOrder(order_id);
                console.log("result get order ===", result);
                if(result.code === 'OK'){
                    setOrder(result.data);
                }else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
            }
        }catch(ex){
            console.log("onLoadOrder exception ===", ex);
        }
    }

    const showMessage = async (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    const onGoBack = (url) => {
        if(getServiceChangeInfo()) setServiceChangeInfo(null);
        props.history.push(url)
    }
    const { classes, t } = props;

    console.log("paygateResult===", paygateResult);
    let currency = getCurrency();
    if(order && order.currency){
        currency = getCurrencySymbol(order.currency);
    }

    if (ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item>
                    <Grid xs={12} item justify='center' container>
                        {paygateResult.status === "SUCCESS" && <SuccessIcon style={{ width: 100, height: 100 }} />}
                        {paygateResult.status !== "SUCCESS" && <ErrorIcon style={{ width: 100, height: 100 }} />}
                    </Grid>
                    {paygateResult.type === 'topup' && <Grid xs={12} item justify='center' container>
                        {paygateResult.status === "SUCCESS" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("TOPUP_ACCOUNT_SUCCESS")}</Typo>}
                        {paygateResult.status !== "SUCCESS" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_ACCOUNT_FAILED')}</Typo>}
                    </Grid>}
                    {paygateResult.type == 'order' && <Grid xs={12} item justify='center' container>
                        {paygateResult.status === "SUCCESS" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("PAYMENT_SUCCESS")}</Typo>}
                    </Grid>}
                    <Grid item xs={12} justify='center' container style={{ marginTop: 32 }}>
                        {paygateResult.status === "ERROR" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('PAYMENT_FAILED')}</Typo>}
                        {paygateResult.status === "CANCEL" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('PAYMENT_CANCEL')}</Typo>}
                    </Grid>
                    {order && <Grid xs={12} item justify='center' container style={{ marginTop: 32 }}>
                        <Grid xs={12} sm={12} md={5} className={classes.boxItemContent}>
                            <Grid xs={12} item container direction='row'>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{'Order Number'}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{order.number}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Total Amount')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{currency}{order.total_cost ? Number(order.total_cost).toFixed(2) : "0.00"}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Created Date')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{order.key_dates && order.key_dates.submitted_on ? formatDateToDDMMYYYYHHSSFrEpoch(order.key_dates.submitted_on) : ""}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Status')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{order.life_cycle_state}</Typo>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>}
                    <Grid xs={12} item container justify='center' style={{ marginTop: 32 }}>
                        {getServiceChangeInfo() ? <Grid xs={3} item container >
                            {paygateResult.type === 'topup' && paygateResult.status === "SUCCESS" ? <Button color='primary' fullWidth onClick={() => props.history.push(paths.subcriptions, {from: 'paygate'})}>{t('Continue Change Service')}</Button>
                            : <Button color='primary' fullWidth onClick={() => onGoBack(paths.subcriptions)}>{t('Go Back')}</Button>}
                        </Grid> :
                        <Grid xs={3} item container >
                            <Button color='primary' fullWidth onClick={() => props.history.push('/home')}>{t('Back to Home Page')}</Button>
                        </Grid>}
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return (
            <Container showLoading={showLoading}>

            </Container>
        )
    }
}

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
});

export default withStyles(styles)(withTranslation()(PaygateResults));